import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import AuthorizeThird from '../../../forms/authorizeThird/AuthorizeThird';
import MotiveTitle from '../MotiveTitle';
import TruckColorIcon from '../../../../../../../common/icons/icr_envio.svg';

const AuthorizeThirdMobile = ({ ...props }) => {
  const {
    motiveId,
    orderId,
    sku,
    product,
    profile,
    selfServiceStatus,
    type,
    validationStatus,
    validation,
    onData,
  } = props;

  return (
    <Box marginTop="28px">
      <MotiveTitle
        title="Despacho y retiro"
        subtitle="Autorizar a un tercero a retirar producto"
        icon={TruckColorIcon}
        mobile
      />
      <AuthorizeThird
        mobile
        motiveId={motiveId}
        orderId={orderId}
        sku={sku}
        product={product}
        profile={profile}
        type={type}
        selfServiceStatus={selfServiceStatus}
        validationStatus={validationStatus}
        validation={validation}
        onData={onData}
      />
    </Box>
  );
};

AuthorizeThirdMobile.propTypes = {
  motiveId: PropTypes.string,
  orderId: PropTypes.string,
  sku: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  selfServiceStatus: PropTypes.string,
  type: PropTypes.string,
  validationStatus: PropTypes.string,
  validation: PropTypes.object,
  onData: PropTypes.func,
};

export default AuthorizeThirdMobile;
